<div class="my-2">
    @if (tableData && tableData.data && isWorkOrderRoute === false) {
    <app-single-input-filter [tableFilters]="tableData.data.tableFilters" (selectedFilter)="onSelectedFilter($event)">
    </app-single-input-filter>
    }

    @if (tableData && tableData.data && isWorkOrderRoute) {
    <app-multiple-input-filter [tableFilters]="tableData.data.tableFilters" (selectedFilter)="onSelectedFilter($event)"
        (exportLoading)="isLoadingResults = $event">
    </app-multiple-input-filter>
    }
</div>

<div class="table-container mat-elevation-z6">
    @if (isLoadingResults) {
    <div class="loading-shade" style="z-index: 1000;">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
    </div>
    }

    <!-- <mat-paginator [pageSizeOptions]="[100, 25, 10]" [length]="length"></mat-paginator> -->
    <mat-paginator [length]="length" [pageSizeOptions]="[100, 25, 10]" class="mat-mdc-paginator classic-paginator">
    </mat-paginator>

    @if (tableData && tableData.data) {
    <div class="table-scroll-container">
        <mat-table [dataSource]="tableData.data.tableRows" multiTemplateDataRows>
            @for (column of tableData.data.tableDefinitions; track customTB($index, column)) {
            <ng-container [matColumnDef]="column.columnDef">
                <mat-header-cell *matHeaderCellDef class="align-row">
                    <span [matTooltip]="column.columnTooltip" matTooltipPosition="below"
                        matTooltipClass="custom-tooltip">{{ column.header }}</span>
                </mat-header-cell>
                <mat-cell class="align-row" *matCellDef="let row; let i = dataIndex">
                    @if ( (column.columnDef !== 'workOrderHistory') && (column.columnDef !== 'visitLink') &&
                    (column.columnDef !== 'workOrderLink') && (column.columnDef !== 'acceptOrReject')) {
                    <span>
                        {{ row[column.columnDef] }}
                    </span>
                    }
                    <div class="download" (click)="$event.stopPropagation();">
                        @if (column.columnDef === 'workOrderHistory') {
                        <span>
                            <button mat-icon-button (click)="openHistory(row,$event)">
                                <mat-icon style="color: rgb(36, 145, 234);">access_time</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    @if (
                    ((isArray() === true) && (column.columnDef === 'visitLink') && (row[column.columnDef] === 'Visit'))
                    ||
                    ((isArray() === false) && (column.columnDef === 'visitLink') && (row[column.columnDef] === 'Visit'))
                    ||
                    (column.columnDef === 'workOrderLink' && row[column.columnDef] === 'Work Order')
                    ) {
                    <span style="display: flex; align-items: center;">
                        <button mat-icon-button
                            (click)="column.columnDef === 'visitLink' ? showVisits(row) : showWorkOrders(row)">
                            <mat-icon>open_in_new</mat-icon>
                        </button>
                    </span>
                    }
                    @if (column.columnDef === 'acceptOrReject' && row[column.columnDef] === 'Accept|Reject') {
                    <span style="display: flex; align-items: center; justify-content: center; width: 100%;">
                        <button mat-icon-button
                            [ngClass]="{'check-active': row.status !== 'ACCEPTED', 'check-not-active' : row.status === 'ACCEPTED' }"
                            (click)="$event.stopPropagation(); accept(row,$event,i)"
                            [disabled]="row.status === 'ACCEPTED'" [hidden]="row.status === 'REJECTED'">
                            <mat-icon>check</mat-icon>
                        </button>
                        @if ((row.status !== 'ACCEPTED' && row.status !== 'REJECTED')) {
                        <span style="color: #9e9e9e; font-size: 16px; user-select: none;"> | </span>
                        }
                        <button mat-icon-button
                            [ngClass]="{'close-active': row.status !== 'REJECTED', 'close-not-active' : row.status === 'REJECTED' }"
                            (click)="$event.stopPropagation(); reject(row,$event,i)"
                            [disabled]="row.status === 'REJECTED'" [hidden]="row.status === 'ACCEPTED'">
                            <mat-icon>close</mat-icon>
                        </button>
                    </span>
                    }
                </mat-cell>
            </ng-container>
            }
            <!-- Extra Empty Column for Expand Arrow -->
            <ng-container matColumnDef="expand">
                <mat-header-cell *matHeaderCellDef
                    style="background-color:#ffffff;flex: 0 0 60px;">&nbsp;</mat-header-cell>
                <mat-cell *matCellDef="let row" style="justify-content: flex-end; padding-right: 24px; flex: 0 0 60px;">
                    <mat-icon style="color: dimgrey; cursor: pointer;">keyboard_arrow_down</mat-icon>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
                <mat-cell *matCellDef="let row; let i = index">
                    <div class="example-element-detail"
                        [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
                        @if (isAccordion && this.showWoAccordion == true) {
                        <div class="row">
                            <div class="col-sm"> <span class="headers"> <u>Addition information</u> </span></div>
                            <div class="w-100"></div>
                            <mat-header-cell *matHeaderCellDef>{{ expandableDisplayedColumns }}</mat-header-cell>
                            <div class="col-sm" style="display: flex;">
                                <div style="margin-right: 5%;">
                                    <div class="headers" [matTooltip]="columnTooltip[0]"> <span>{{
                                            expandableDisplayedColumns[0] }}:</span>
                                    </div>
                                    <div class="headers" [matTooltip]="columnTooltip[3]"><span> {{
                                            expandableDisplayedColumns[3] }}: </span>
                                    </div>
                                    <div class="headers" [matTooltip]="columnTooltip[6]"><span> {{
                                            expandableDisplayedColumns[6] }}: </span>
                                    </div>
                                    <div class="headers" [matTooltip]="columnTooltip[9]"><span> {{
                                            expandableDisplayedColumns[9] }}:</span>
                                    </div>
                                    @if (expandableDisplayedColumns[10] === 'Sub Category' && row.subCategory !== null)
                                    {
                                    <div class="headers" [matTooltip]="columnTooltip[10]"><span> {{
                                            expandableDisplayedColumns[10] }}:</span></div>
                                    }
                                </div>
                                <div>
                                    <div class="accordionrow"><span class="accordionrow"> {{row.priorityName}}</span>
                                    </div>
                                    <div class="traderow"><span> {{row.type}} </span></div>
                                    <div class="accordionrow"><span class="accordionrow"> {{row.trade}}</span> </div>
                                    <div class="accordionrow"><span class="accordionrow"> {{row.price}}</span></div>
                                    @if (expandableDisplayedColumns[10] === 'Sub Category' && row.subCategory !== null)
                                    {
                                    <div class="accordionrow"><span class="accordionrow"> {{row.subCategory}}</span>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div class="col-sm" style="display: flex;">
                                <div style="margin-right: 5%;">
                                    <div class="headers" [matTooltip]="columnTooltip[1]"> <span> {{
                                            expandableDisplayedColumns[1] }}:</span>
                                    </div>
                                    <div class="headers" [matTooltip]="columnTooltip[4]"><span> {{
                                            expandableDisplayedColumns[4] }}: </span>
                                    </div>
                                    @if (expandableDisplayedColumns[10] === 'Visit type' &&
                                    expandableDisplayedColumns[7] === 'Contract') {
                                    <div class="headers" [matTooltip]="columnTooltip[7]"
                                        [matTooltip]="columnTooltip[10]"><span> {{
                                            expandableDisplayedColumns[7] }}|{{ expandableDisplayedColumns[10] }}:
                                        </span></div>
                                    }
                                    @if (expandableDisplayedColumns[11] === 'Visit type' &&
                                    expandableDisplayedColumns[7] === 'Contract') {
                                    <div class="headers" [matTooltip]="columnTooltip[7]"
                                        [matTooltip]="columnTooltip[11]"><span> {{
                                            expandableDisplayedColumns[7] }}|{{ expandableDisplayedColumns[11]
                                            }}:</span></div>
                                    }
                                    @if (expandableDisplayedColumns[11] === 'Scheduled Date') {
                                    <div class="headers" [matTooltip]="columnTooltip[11]"><span> {{
                                            expandableDisplayedColumns[11] }}: </span></div>
                                    }
                                    @if (expandableDisplayedColumns[12] === 'Scheduled Date') {
                                    <div class="headers" [matTooltip]="columnTooltip[12]"><span> {{
                                            expandableDisplayedColumns[12] }}: </span></div>
                                    }
                                </div>
                                <div>
                                    <div class="accordionrow"><span class="accordionrow"> {{row.accountNumber}}</span>
                                    </div>
                                    <div class="accordionrow"><span class="accordionrow"> {{row.contractNumber}} </span>
                                    </div>
                                    @if (expandableDisplayedColumns[10] === 'Visit type' &&
                                    expandableDisplayedColumns[7] === 'Contract') {
                                    <div class="accordionrow">
                                        <span class="accordionrow"> {{row.contractTypeCode}} |
                                            {{row.visitType}}</span>
                                    </div>
                                    }
                                    @if (expandableDisplayedColumns[11] === 'Visit type' &&
                                    expandableDisplayedColumns[7] === 'Contract') {
                                    <div class="accordionrow">
                                        <span class="accordionrow"> {{row.contractTypeCode}} |
                                            {{row.visitType}}</span>
                                    </div>
                                    }
                                    @if (expandableDisplayedColumns[11] === 'Scheduled Date') {
                                    <div class="accordionrow"><span class="accordionrow"> {{row.scheduledDate}} </span>
                                    </div>
                                    }
                                    @if (expandableDisplayedColumns[12] === 'Scheduled Date') {
                                    <div class="accordionrow"><span class="accordionrow"> {{row.scheduledDate}} </span>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div class="col-sm" style="display: flex;">
                                <div style="margin-right: 5%;">
                                    <div class="headers" [matTooltip]="columnTooltip[2]"> <span> {{
                                            expandableDisplayedColumns[2] }}:</span>
                                    </div>
                                    <div class="headers" [matTooltip]="columnTooltip[5]"><span> {{
                                            expandableDisplayedColumns[5] }}:</span>
                                    </div>
                                    <div class="headers" [matTooltip]="columnTooltip[8]"><span> {{
                                            expandableDisplayedColumns[8] }}: </span>
                                    </div>
                                    <!-- Pest control -->
                                    @if (environment.region === 'US' && row.viewPestInfoLink) {
                                    <div class="headers" [matTooltip]="columnTooltip[14]"><span>
                                            {{expandableDisplayedColumns[14] }}: </span>
                                    </div>
                                    }
                                    <!-- Pest control -->
                                </div>
                                <div>
                                    <div class="accordionrow"><span> {{row.geoCoordinates}}</span> </div>
                                    @if (checkIsPosLink(row) == true) {
                                    <div class="accordionrow">
                                        <span>
                                            <mat-icon class="pos-alignment" (click)="downloadPOSLogic(row)">
                                                vertical_align_bottom
                                            </mat-icon>
                                        </span>
                                    </div>
                                    }
                                    @if (checkIsPosLink(row) == false) {
                                    <div class="accordionrow">
                                        <span> {{row.downloadPOSLink}} </span>
                                    </div>
                                    }
                                    @if (row.downloadInvoiceLink === '11') {
                                    <div class="accordionrow">
                                        <span>
                                            <mat-icon class="pos-alignment"
                                                (click)="downloadInvoiceLogic(row)">vertical_align_bottom</mat-icon>
                                            <mat-icon class="pos-alignment"
                                                (click)="openInvoice(row,$event)">description</mat-icon>
                                        </span>
                                    </div>
                                    }
                                    @if (row.downloadInvoiceLink === '10') {
                                    <div class="accordionrow">
                                        <span>
                                            <mat-icon class="pos-alignment"
                                                (click)="downloadInvoiceLogic(row)">vertical_align_bottom</mat-icon>
                                        </span>
                                    </div>
                                    }
                                    @if (row.downloadInvoiceLink === '01') {
                                    <div class="accordionrow">
                                        <span>
                                            <mat-icon class="pos-alignment"
                                                (click)="openInvoice(row,$event)">description</mat-icon>
                                        </span>
                                    </div>
                                    }
                                    @if (row.downloadInvoiceLink === 'Currently unavailable' || row.downloadInvoiceLink
                                    === 'Not applicable') {
                                    <div class="accordionrow" [ngClass]="{
                       'isInvoice': checkIsPosLink(row) === true,
                       'not-Invoice': checkIsPosLink(row) === false
                     }">
                                        <span> {{row.downloadInvoiceLink}} </span>
                                    </div>
                                    }
                                    <!-- Pest control -->
                                    @if (environment.region === 'US' && row.viewPestInfoLink === viewPestInfoLinkBackendNameNA) {
                                    <div class="accordionrow">
                                        <span> {{row.viewPestInfoLink}} </span>
                                    </div>
                                    }
                                    @if (environment.region === 'US' && row.viewPestInfoLink === '1') {
                                    <div class="accordionrow">
                                        <span>
                                            <mat-icon class="pest-alignment"
                                                (click)="openPestInformation(row,$event)">description</mat-icon>
                                        </span>
                                    </div>
                                    }
                                    <!-- Pest control end -->
                                </div>
                            </div>
                            <div class="w-100"></div>
                            @if (expandableDisplayedColumns[12] === 'Description') {
                            <div class="col-sm"><span class="headers" [matTooltip]="columnTooltip[12]"> {{
                                    expandableDisplayedColumns[12] }}: </span>
                                <span class="description"> {{row.description}} </span>
                            </div>
                            }
                            @if (expandableDisplayedColumns[12] === 'Work Order Description') {
                            <div class="col-sm"><span class="headers" [matTooltip]="columnTooltip[12]"> {{
                                    expandableDisplayedColumns[12] }}: </span>
                                <span class="description"> {{row.description}} </span>
                            </div>
                            }
                            @if (expandableDisplayedColumns[13] === 'Problem Description') {
                            <div class="col-sm"><span class="headers" [matTooltip]="columnTooltip[13]"> {{
                                    expandableDisplayedColumns[13] }}: </span>
                                <span class="description"> {{row.description}} </span>
                            </div>
                            }
                            <div class="w-100"></div>
                            @if (expandableDisplayedColumns[13] === 'Status Text') {
                            <div class="col-sm"> <span class="headers" [matTooltip]="columnTooltip[13]"> {{
                                    expandableDisplayedColumns[13] }}: </span>
                                <span class="accordionrow"> {{row.statusText}} </span>
                            </div>
                            }
                            @if (expandableDisplayedColumns[14] === 'Status Text') {
                            <div class="col-sm"> <span class="headers" [matTooltip]="columnTooltip[14]"> {{
                                    expandableDisplayedColumns[14] }}: </span>
                                <span class="accordionrow"> {{row.statusText}} </span>
                            </div>
                            }
                        </div>
                        }
                        @if (isAccordion && this.showVisitsAccordion == true) {
                        <div class="row">
                            <div class="col-sm"> <span class="headers"> <u>Addition information</u> </span></div>
                            <div class="w-100"></div>
                            <mat-header-cell *matHeaderCellDef>{{ expandableDisplayedColumns }}</mat-header-cell>
                            <div class="col-sm info-grid-column">
                                <div class="headers" style="width: max-content;" [matTooltip]="columnTooltip[0]">
                                    <span>{{
                                        expandableDisplayedColumns[0] }}:</span></div>
                                <div class="accordionrow"><span class="accordionrow"> {{row.contractNumber}}</span>
                                </div>
                                <div class="headers" [matTooltip]="columnTooltip[3]"><span> {{
                                        expandableDisplayedColumns[3] }}: </span></div>
                                <div class="accordionrow"><span class="accordionrow"> {{row.productCode}} </span></div>
                            </div>
                            <div class="col-sm info-grid-column">
                                <div class="headers" style="width: max-content;" [matTooltip]="columnTooltip[1]"> <span>
                                        {{
                                        expandableDisplayedColumns[1] }}:</span></div>
                                <div class="accordionrow" style="width: 100%; white-space: normal; min-width: 0;"><span
                                        class="accordionrow truncate-two-lines"> {{row.visitId}}</span> </div>

                                <div class="headers" style="width: max-content;" [matTooltip]="columnTooltip[4]"><span>
                                        {{
                                        expandableDisplayedColumns[4] }}: </span></div>
                                <div class="accordionrow" style="width: max-content;"><span class="accordionrow">
                                        {{row.serviceCoverRef}} </span>
                                </div>
                                <div class="headers" [matTooltip]="columnTooltip[7]"><span> {{
                                        expandableDisplayedColumns[7] }}: </span></div>
                                <div class="accordionrow"><span class="accordionrow"> {{row.visitType}} </span></div>
                            </div>

                            <div class="col-sm info-grid-column">
                                <div class="headers" [matTooltip]="columnTooltip[2]"> <span> {{
                                        expandableDisplayedColumns[2] }}:</span> </div>
                                <div class="accordionrow"><span class="accordionrow"> {{row.employeeId}}</span> </div>

                                <div class="headers" style="width: max-content;" [matTooltip]="columnTooltip[5]"><span>
                                        {{
                                        expandableDisplayedColumns[5] }}:</span></div>
                                <div class="accordionrow"><span class="accordionrow"> {{row.geoCoordinates}}</span>
                                </div>

                                <ng-container *ngIf="checkIsVisitPosLink(row) == true">
                                    <div class="headers" [matTooltip]="columnTooltip[9]"><span> {{
                                            expandableDisplayedColumns[9] }}: </span></div>
                                    <div class="accordionrow">
                                        <mat-icon class="pos-alignment"
                                            (click)="downloadPOSVisitLogic(row)">vertical_align_bottom</mat-icon>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="w-100"></div>
                            <div class="col-sm"><span class="headers" [matTooltip]="columnTooltip[6]"> {{
                                    expandableDisplayedColumns[6]
                                    }}: </span>
                                <span class="description"> {{row.visitNotes}} </span>
                            </div>
                            <div class="w-100"></div>
                            <div class="col-sm"> <span class="headers" [matTooltip]="columnTooltip[8]"> {{
                                    expandableDisplayedColumns[8]
                                    }}: </span>
                                <span class="description"> {{row.statusText}} </span>
                            </div>
                        </div>
                        }
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="tableDisplayedColumns.concat(['expand']); sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableDisplayedColumns.concat(['expand']);" let dataIndex="dataIndex"
                class="example-element-row" [class.example-expanded-row]="expandedElement === row"
                (click)="expandedElement = expandedElement === row ? null : row"></mat-row>
            <mat-row *matRowDef="let row; columns: ['expandedDetail']" let dataIndex="dataIndex"
                class="example-detail-row" style="min-height: 0;"></mat-row>
        </mat-table>
    </div>
    }
</div>